var render = function render(){var _vm=this,_c=_vm._self._c;return _c('state-container',{attrs:{"status":"failed","actions":_vm.actions,"is-collapsible":""}},[_c('span',{staticClass:"gl-font-bold"},[(_vm.mergeError)?[_vm._v(_vm._s(_vm.mergeError))]:_vm._e(),_vm._v("\n    "+_vm._s(_vm.s__('mrWidget|This merge request failed to be merged automatically'))+"\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }